import React, { useState, useEffect, useRef, useMemo } from "react";
import axios from "axios";
import TagInput from "./utils/TagInput.js";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalButton,
  SIZE,
  ROLE,
} from "baseui/modal";
import { KIND as ButtonKind } from "baseui/button";
import { Input } from "baseui/input";
import { FormControl } from "baseui/form-control";
// import { use } from "react";

const NewVideoModal = ({ isOpen, setIsOpen, editObj, setEditObj }) => {
  console.log("received editObj", editObj);
  const apiUrl = process.env.REACT_APP_API_URL;

  const [availableTags, setAvailableTags] = useState([
    "Body",
    "Interior",
    "Brakes",
    "Suspension",
    "Transmission",
  ]);

  // Form values
  const [editId, setEditId] = useState();
  const [newVideoName, setNewVideoName] = useState("");
  const [newVideoDescription, setNewVideoDescription] = useState("");
  const [newVideoURL, setNewVideoURL] = useState("");
  const [newVideoTags, setNewVideoTags] = useState([]);

  useEffect(() => {
    if (editObj) {
      setEditId(editObj.id);
      setNewVideoName(editObj.name || "");
      setNewVideoDescription(editObj.description || "");
      setNewVideoURL(editObj.url || "");
      setNewVideoTags(editObj.tags ? editObj.tags.split(",") : []); // Assuming tags are stored as a comma-separated string
      // setNewVideoTags(editObj.tags || "");
    }
  }, [editObj]);

  // Form object
  const newVideoObject = {
    name: newVideoName,
    description: newVideoDescription,
    url: newVideoURL,
    tags: newVideoTags,
  };

  const updatedVideoObject = React.useMemo(() => ({
    id: editId, // Ensure you're using the correct id
    name: newVideoName,
    description: newVideoDescription,
    url: newVideoURL,
    tags: newVideoTags,
  }), [editId, newVideoName, newVideoDescription, newVideoURL, newVideoTags]);

  useEffect(() => {
    console.log("updateVideoObject:", updatedVideoObject);
  }, [updatedVideoObject]);

  const formRef = useRef(null);

  // Keydown handler
  const inputsKeyDownHandler = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      // formRef.current.submit();
    }
  };

  // Submit form
  const handleCreateVideo = async (e) => {
    e.preventDefault();
    if (
      !newVideoName ||
      !newVideoDescription ||
      !newVideoURL ||
      newVideoTags.length === 0
    ) {
      alert("All fields are required.");
      return;
    }

    try {
      const response = await axios.post(
        `${apiUrl}/api/add/training`,
        newVideoObject
      );
      if (response.data.success) {
        alert("Training video added successfully!");
        // Clear form and tags
        setNewVideoName("");
        setNewVideoDescription("");
        setNewVideoURL("");
        setNewVideoTags([]);
        setIsOpen(false);

        window.location.reload();
      } else {
        alert("Failed to add training video.");
      }
    } catch (error) {
      console.error("Error adding training video:", error);
      alert("Error adding training video.");
    }
  };

  const handleEdit = async (e) => {
    // console.log("updateVideoObject")
    if (!editObj) {
      alert("No video selected for editing.");
      return;
    }
    e.preventDefault();
    if (
      !newVideoName ||
      !newVideoDescription ||
      !newVideoURL ||
      newVideoTags.length === 0
    ) {
      alert("All fields are required.");
      return;
    }

    try {
      const response = await axios.post(
        `${apiUrl}/api/edit/training`,
        updatedVideoObject
      );
      if (response.data.success) {
        alert("Training video updated successfully!"); // Update success message
        // Clear form and tags
        setNewVideoName("");
        setNewVideoDescription("");
        setNewVideoURL("");
        setNewVideoTags([]);
        setIsOpen(false);

        window.location.reload();
      } else {
        alert("Failed to update training video.");
      }
    } catch (error) {
      console.error("Error updating training video:", error);
      alert("Error updating training video.");
    }
  };

  const handleDeleteVideo = async (e) => {
    e.preventDefault();

    if (!editObj || !editObj.id) {
      alert("No video selected for deletion.");
      return;
    }

    if (window.confirm("Are you sure you want to delete this video?")) {
      try {
        const response = await axios.delete(`${apiUrl}/api/remove/training`, {
          data: { id: updatedVideoObject.id },
        });

        if (response.data.success) {
          alert("Training video deleted successfully!");
          setIsOpen(false);
          setEditObj({});
          window.location.reload(); // Optionally reload to refresh the list of videos
        } else {
          alert("Failed to delete training video.");
        }
      } catch (error) {
        console.error("Error deleting training video:", error);
        alert("Error deleting training video.");
      }
    }
  };

  return (
    <Modal
      onClose={() => {
        setIsOpen(false);
        setEditObj({});
      }}
      closeable
      isOpen={isOpen}
      animate
      autoFocus
      size={SIZE.default}
      role={ROLE.dialog}
    >
      <ModalHeader>
        {editObj && Object.keys(editObj).length > 0
          ? "Edit Video"
          : "New Video"}
      </ModalHeader>

      <ModalBody>
        <form
          ref={formRef}
          onSubmit={
            Object.keys(editObj).length > 0 ? handleEdit : handleCreateVideo
          }
        >
          <FormControl label="Video Name">
            <Input
              value={newVideoName}
              onChange={(e) => setNewVideoName(e.target.value)}
              onKeyDown={inputsKeyDownHandler}
              required
              clearable
            />
          </FormControl>
          <FormControl label="Video URL">
            <Input
              value={newVideoURL}
              onChange={(e) => setNewVideoURL(e.target.value)}
              onKeyDown={inputsKeyDownHandler}
              required
              clearable
            />
          </FormControl>
          <FormControl label="Video Description">
            <Input
              value={newVideoDescription}
              onChange={(e) => setNewVideoDescription(e.target.value)}
              onKeyDown={inputsKeyDownHandler}
              required
              clearable
            />
          </FormControl>
          <FormControl label="Tags">
            <TagInput
              setNewVideoTags={setNewVideoTags}
              newVideoTags={newVideoTags}
              availableTags={availableTags}
              setAvailableTags={setAvailableTags}
            />
          </FormControl>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "1rem",
            }}
          >
            <ModalButton
              kind={ButtonKind.tertiary}
              onClick={() => setIsOpen(false)}
            >
              Cancel
            </ModalButton>
            <ModalButton
              style={{ backgroundColor: "red", color: "white" }}
              kind={ButtonKind.tertiary}
              onClick={handleDeleteVideo}
            >
              Delete Video
            </ModalButton>
            <ModalButton type="submit">
              {editObj && Object.keys(editObj).length > 0
                ? "Update Video"
                : "Add Video"}
            </ModalButton>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default NewVideoModal;
